import { createGlobalStyle } from 'styled-components/macro';

import { Theme } from 'common/types/theme.type';

export const StyledGlobal = createGlobalStyle<{
  theme: Theme;
}>`
  body,
  html,
  #root {
    height: 100%;
    overflow-y: hidden;
  }

  $primary-color: #1e2457;
  $primary-lighter-color: #646a9c;
  $secondary-color: #f15e75;
  $error-color: #eb5454;
  $success-color: #3fe0a3;
  $info-color: #5db6ff;
  $warning-color: #f0ab45;
  $card-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  $font-family-base: ${({ theme }) => theme.fonts.fontFamily};

  body {
    font-family: ${({ theme }) => theme.fonts.fontFamily};
    --bs-body-font-family: ${({ theme }) => theme.fonts.fontFamily};
    --bs-font-sans-serif: ${({ theme }) => theme.fonts.fontFamily};
    --mainBg: ${({ theme }) => theme.colors.mainBg};
    --footerBg: ${({ theme }) => theme.colors.footerBg};
    --primaryBlue1: ${({ theme }) => theme.colors.primaryBlue1};
    --primaryBlue2: ${({ theme }) => theme.colors.primaryBlue2};
    --primaryBlue3: ${({ theme }) => theme.colors.primaryBlue3};
    --primaryBlue4: ${({ theme }) => theme.colors.primaryBlue4};
    --primaryBlue5: ${({ theme }) => theme.colors.primaryBlue5};
    --primaryGrey: ${({ theme }) => theme.colors.primaryGrey};
    --primaryWhite: ${({ theme }) => theme.colors.primaryWhite};
    --secondaryGrey: ${({ theme }) => theme.colors.secondaryGrey};
    --primaryStroke: ${({ theme }) => theme.colors.primaryStroke};
    --secondaryStroke: ${({ theme }) => theme.colors.secondaryStroke};
    --chips: ${({ theme }) => theme.colors.chips};
    --severity0: ${({ theme }) => theme.colors.severity0};
    --severity1: ${({ theme }) => theme.colors.severity1};
    --severity2: ${({ theme }) => theme.colors.severity2};
    --severity3: ${({ theme }) => theme.colors.severity3};
    --severity4: ${({ theme }) => theme.colors.severity4};
    --severity5: ${({ theme }) => theme.colors.severity5};
    --info: ${({ theme }) => theme.colors.info};
    --success: ${({ theme }) => theme.colors.success};
    --error: ${({ theme }) => theme.colors.error};
    --disabled1: ${({ theme }) => theme.colors.disabled1};
    --disabled2: ${({ theme }) => theme.colors.disabled2};
    --disabled4: ${({ theme }) => theme.colors.disabled4};
    --suridataRed: ${({ theme }) => theme.colors.suridataRed};
    --circleBlue: ${({ theme }) => theme.colors.circleBlue};
    --scrollThumb: ${({ theme }) => theme.colors.scrollThumb};
    --scrollBg: ${({ theme }) => theme.colors.scrollBg};

    *,
    :after,
    :before {
      border: 0;
    }
  }

  p {
    margin-top: none !important;
    margin-bottom: none !important;
  }

  .confirmationModal {
    z-index: 1300;
    position: relative;
  }

  .clickable {
    cursor: pointer;
    text-decoration: underline;
  }

  .btn-link {
    outline: 0;
    border: 0;
    box-shadow: none;
    padding: 5px !important;
    background: transparent;
    color: #1e2457;
    font-weight: 600;
  }

  .spinner-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .add-new-policy {
    font-size: 14px;
    cursor: pointer;
    position: relative;
    display: inline-flex;
    justify-self: end;
    align-items: center;
    border: none;
    outline: none;
  }

  .icon {
    color: #1e2457 !important;
  }

  .icon:hover {
    color: #3d48ad !important;
  }

  .table-row-wrapper {
    cursor: pointer;
    background-color: #ffffff;
  }

  .file-info-card {
    box-shadow: none;
    background-color: #fff;
    border-radius: 3px;

    .progress-bar-container {
      position: relative;
      top: 20%;
      width: 80%;
    }

    .search-page-progress-bar {
      box-shadow: none;
    }

    .icon-small {
      position: relative;
      width: 13px;
      height: 13px;
      margin: 0px 10px 5px 0;
      border-radius: none;
    }

    .icon-big {
      position: absolute;
      right: 20px;
      bottom: 20px;
      width: 26%;
    }

    .info-title {
      background: transparent;
      border: none;
      box-shadow: none;
      display: initial;
      text-transform: capitalize;
      color: #1e2457;
      font-weight: 500;
    }

    .title-line {
      position: absolute;
      left: 0;
      height: 2px;
      background-color: #4f689a;
    }
  }

  .content {
    padding: 10px 20px 20px 20px;
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
`;
